/* eslint-disable no-restricted-globals */
import MessageModal from "components/shared-components/MessageModal";
import { useCheckRole, useMyHubsList } from "hooks";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";
import {
  changeLayout,
  changeLayoutWidth,
  changeTopbarTheme,
} from "store/actions";
import { AUTH_TOKEN, FORCE_CHANGE_PASS } from "store/auth/login/actionTypes";
import Rightbar from "../CommonForBoth/RightSidebar";
import Footer from "./Footer";
import Header from "./Header";
import Navbar from "./Navbar";

const Layout = props => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation(["common"]);

  const { isHubAdmin, isLogAdmin } = useCheckRole();
  const [isOpenNotificationHub, setIsOpenNotificationHub] = useState(false);

  const layoutRedux = useSelector(state => state.Layout);
  const { topbarTheme, layoutWidth, isPreloader, showRightSidebar } =
    layoutRedux;

  const { data: myHubs, refetch: refetchMyHubs } = useMyHubsList({
    enabled: isHubAdmin || isLogAdmin,
    params: {
      is_new_address: "O",
    },
  });
  /*
  document title
  */
  // useEffect(() => {
  //   const title = location.pathname;
  //   let currentage = title.charAt(1).toUpperCase() + title.slice(2);

  //   document.title = currentage + " | Skote - React Admin & Dashboard Template";
  // }, [location.pathname]);

  useEffect(() => {
    // force-change-password
    if (
      location.pathname !== "/change-password" &&
      localStorage.getItem(FORCE_CHANGE_PASS) === "true"
    ) {
      navigate("/change-password");
    }
    if (!localStorage.getItem(AUTH_TOKEN)) {
      navigate("/login");
    }
    window.scrollTo(0, 0);
    if (isHubAdmin || isLogAdmin) {
      refetchMyHubs();
    }
  }, [isHubAdmin, isLogAdmin]);

  useEffect(() => {
    if ((isHubAdmin || isLogAdmin) && myHubs && !myHubs.hub) {
      setIsOpenNotificationHub(true);
    }
  }, [myHubs, isHubAdmin, isLogAdmin]);

  /*
  layout settings
  */
  useEffect(() => {
    dispatch(changeLayout("horizontal"));
  }, [dispatch]);

  useEffect(() => {
    if (isPreloader === true) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }, 2500);
    } else {
      document.getElementById("preloader").style.display = "none";
      document.getElementById("status").style.display = "none";
    }
  }, [isPreloader]);

  useEffect(() => {
    if (topbarTheme) {
      dispatch(changeTopbarTheme(topbarTheme));
    }
  }, [dispatch, topbarTheme]);

  useEffect(() => {
    if (layoutWidth) {
      dispatch(changeLayoutWidth(layoutWidth));
    }
  }, [dispatch, layoutWidth]);

  const [isMenuOpened, setIsMenuOpened] = useState(false);
  const openMenu = () => {
    setIsMenuOpened(!isMenuOpened);
  };

  return (
    <React.Fragment>
      {/* <AutoLogoutUser /> */}
      <div id="preloader">
        <div id="status">
          <div className="spinner-chase">
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
          </div>
        </div>
      </div>
      <MessageModal
        centered
        isOpen={isOpenNotificationHub}
        toggle={() => setIsOpenNotificationHub(prev => !prev)}
        message={t("message.notAnyHub")}
      />

      <div id="layout-wrapper">
        <Header
          theme={topbarTheme}
          isMenuOpened={isMenuOpened}
          openLeftMenuCallBack={openMenu}
        />
        <Navbar menuOpen={isMenuOpened} />
        <div className="main-content">
          <Outlet />
        </div>
        <Footer />
      </div>

      {showRightSidebar ? <Rightbar /> : null}
    </React.Fragment>
  );
};

Layout.propTypes = {
  changeLayout: PropTypes.func /*  */,
  changeLayoutWidth: PropTypes.func,
  changeTopbarTheme: PropTypes.func,
  children: PropTypes.object,
  isPreloader: PropTypes.any,
  layoutWidth: PropTypes.any,
  showRightSidebar: PropTypes.any,
  topbarTheme: PropTypes.any,
};

export default Layout;
